import { useMemo } from 'react';
import { cebulaCompare } from '../../../logic/arrays';
import TrainerRow from './TrainerRow';

const TrainersList = ({
    val,
    showCheckboxes,
    keyElement,
    onChangeCheckedTrainers,
    checkedTrainers,
}) => {
    const sortedTrainers = useMemo(() => {
        if (!val) return [];
        return Object.values(val).sort((a, b) => {
            const lastname = cebulaCompare(a.lastname, b.lastname);
            if (lastname) return lastname;

            const firstname = cebulaCompare(a.firstname, b.firstname);
            if (firstname) return firstname;

            return 0;
        });
    }, [val]);

    return (
        <>
            {sortedTrainers.map((trainer) => (
                <TrainerRow
                    key={trainer.id}
                    trainer={trainer}
                    showCheckboxes={showCheckboxes}
                    keyElement={keyElement}
                    onChangeCheckedTrainers={onChangeCheckedTrainers}
                    checkedTrainers={checkedTrainers}
                />
            ))}
        </>
    );
};

export default TrainersList;
